import { setLogin, setUser, setUsers } from "../state";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Helper function to get Authorization header
const authHeader = (getState) => ({
  Authorization: `Bearer ${getState().token}`,
  "Content-Type": "application/json",
});

// Login user
export const loginUser = (values) => async (dispatch) => {
  try {
    const loggedInResponse = await fetch(`${BASE_URL}/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(values),
    });
    const loggedIn = await loggedInResponse.json();

    if (loggedIn) {
      dispatch(
        setLogin({
          user: loggedIn.user,
          token: loggedIn.token,
        })
      );
    }

    return loggedIn;
  } catch (error) {
    console.error("Error while logging in:", error);
    return null;
  }
};

// Fetch a single user by ID
export const fetchUser = (id) => async (dispatch, getState) => {
  try {
    const userResponse = await fetch(`${BASE_URL}/users/${id}`, {
      method: "GET",
      headers: authHeader(getState),
    });

    const user = await userResponse.json();

    dispatch(setUser(user));

    return user;
  } catch (error) {
    console.error("Error while fetching user:", error);
    return null;
  }
};

// Fetch all users with optional filters
export const fetchUsers =
  (filters = {}) =>
  async (dispatch, getState) => {
    try {
      const query = new URLSearchParams(filters).toString();
      const usersResponse = await fetch(`${BASE_URL}/users?${query}`, {
        method: "GET",
        headers: authHeader(getState),
      });

      const data = await usersResponse.json();

      dispatch(setUsers({ data: data.users, total: data.total }));

      return data;
    } catch (error) {
      console.error("Error while fetching users:", error);
      return null;
    }
  };

// Update an existing user
export const updateUser = (id, values) => async (dispatch, getState) => {
  try {
    const res = await fetch(`${BASE_URL}/users/${id}`, {
      method: "PATCH",
      headers: authHeader(getState),
      body: JSON.stringify(values),
    });
    const data = await res.json();
    if (!res.ok) throw data;

    // re-load the table after a successful update
    await dispatch(fetchUsers());

    return { payload: data, error: null };
  } catch (err) {
    console.error("Error updating user:", err);
    return { payload: null, error: err };
  }
};

// Delete a user
export const deleteUser = (id) => async (dispatch, getState) => {
  try {
    const response = await fetch(
      `${BASE_URL}/users/${id}`,
      {
        method: "DELETE",
      },
      {
        headers: authHeader(getState),
      }
    );

    const result = await response.json();

    return result;
  } catch (error) {
    console.error("Error while deleting user:", error);
    return null;
  }
};

export const sendUserWelcomeEmail = (userId) => async (dispatch, getState) => {
  try {
    const token = getState().token;

    const response = await fetch(`${BASE_URL}/users/welcome-email`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ userId }), // You'll need to pass the userId as body param if using POST like this
    });

    if (!response.ok) {
      throw new Error("Failed to send welcome email");
    }

    const result = await response.json();

    return result;
  } catch (error) {
    console.error("Error while sending welcome email:", error.message);
    return null;
  }
};
